import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

import { PortalCurrencyPipe } from '@app/pipes/portal-currency.pipe';

@Component({
  selector: 'radio-toggle-button',
  templateUrl: './radio-toggle-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioToggleButtonComponent {
  @Input() title: string;
  @Input() dataId: string;
  @Input() isWritable: boolean;
  @Input() isSelected: boolean;
  @Input() value: string | number | null;
  @Input() isError = false;

  @Output() valueChange = new EventEmitter<string>();
  @Output() valueInputFocusOut = new EventEmitter<string>();

  portalCurrency = inject(PortalCurrencyPipe);

  get editValue() {
    return this.value == null ? '' : String(this.value);
  }

  get displayValue() {
    if (this.value == null || this.value === '') {
      return '';
    }

    return this.portalCurrency.transform(Number(this.value));
  }
}
